module.exports = __webpack_public_path__ + "5a4a8bbcf5f0f3193d161138b8f4b4f4.fbx";